// extracted by mini-css-extract-plugin
export default {"titleContainer":"D2LAuthTokenPage_titleContainer__ICeIz"};